import { useParams, Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Sparkles } from "lucide-react";

const MODULE_NAMES = {
  orders: "Comenzi",
  shipping: "Livrări",
  billing: "Facturare",
  analytics: "Analytics",
  products: "Produse",
  ai: "AI Assistant",
  ads: "Ads Performance",
  support: "Customer Support",
  sms: "SMS",
  email: "Email Marketing",
};

export default function PlaceholderModulePage() {
  const { moduleId } = useParams();
  const name = MODULE_NAMES[moduleId] || moduleId;

  return (
    <div className="max-w-2xl mx-auto py-16" data-testid="placeholder-module">
      <Link to="/" className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5 mb-6">
        <ArrowLeft className="h-3.5 w-3.5" /> Înapoi la dashboard
      </Link>
      <Card className="p-12 text-center bg-card border-border">
        <div className="h-14 w-14 rounded-xl bg-primary/10 mx-auto flex items-center justify-center mb-6">
          <Sparkles className="h-6 w-6 text-primary" />
        </div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-2">Modul · {name}</div>
        <h1 className="font-display text-3xl font-bold tracking-tight mb-3">Curând disponibil</h1>
        <p className="text-muted-foreground text-sm leading-relaxed mb-6 max-w-md mx-auto">
          Modulul <strong>{name}</strong> este pregătit în arhitectură și va fi activat într-o iterație viitoare.
          Sistemul modular permite dezvoltare și activare independentă per modul.
        </p>
        <Link to="/"><Button variant="outline">Înapoi la Overview</Button></Link>
      </Card>
    </div>
  );
}
